"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReferralCreditApplicationStatusEnum = void 0;
var ReferralCreditApplicationStatusEnum;
(function (ReferralCreditApplicationStatusEnum) {
    ReferralCreditApplicationStatusEnum["Reserved"] = "reserved";
    ReferralCreditApplicationStatusEnum["Applied"] = "applied";
    ReferralCreditApplicationStatusEnum["Released"] = "released";
})(ReferralCreditApplicationStatusEnum = exports.ReferralCreditApplicationStatusEnum || (exports.ReferralCreditApplicationStatusEnum = {}));
//# sourceMappingURL=referral-credit-application-status-enum.js.map